module.exports = __webpack_public_path__ + "static/media/download_link.0cab37c5.svg";